var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
export var MobilePhoneRegExp = /^1\d{10}$/;
// /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/
export var EMPTY_OBJECT = Object.freeze({});
export var EMPTY_ARRAY = [];
export var NOOP = function () {
    // do nothing.
};
var hasOwnProperty = Object.prototype.hasOwnProperty;
export var hasOwn = function (val, key) {
    return hasOwnProperty.call(val, key);
};
export var isArray = Array.isArray;
export var isString = function (val) { return typeof val === 'string'; };
export var isNumber = function (val) { return typeof val === 'number'; };
export var isSymbol = function (val) { return typeof val === 'symbol'; };
export var isFunction = function (val) { return typeof val === 'function'; };
export var isObject = function (val) {
    return val !== null && typeof val === 'object';
};
export var isInvalid = function (val) {
    return val === void 0 || val === null;
};
export var isValid = function (val) {
    return isInvalid(val) === false;
};
export var classNames = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args
        .reduce(function (classes, item) {
        // 字符串或者数据时，直接添加进 classes
        if (isString(item) || isNumber(item)) {
            classes.push(item);
        }
        // 为对象时
        else if (isObject(item)) {
            if (item.toString !== Object.prototype.toString) {
                classes.push(item.toString());
            }
            // 普通对象，遍历 keys
            else {
                classes.push.apply(void 0, Object.keys(item)
                    .map(function (key) { return item[key]; })
                    .filter(Boolean));
            }
        }
        // 为数组时
        else if (Array.isArray(item)) {
            classes.push(classNames.apply(void 0, __spreadArrays(item)));
        }
        return classes;
    }, [])
        .join(' ')
        .trim();
};
export var encryptToBase64 = function (val, key) {
    return window.XXTEA.encryptToBase64(val, key);
};
export var decryptFromBase64 = function (base64, key) {
    return window.XXTEA.decryptFromBase64(base64, key);
};
export var uuid = function () {
    return "" + new Date().getTime();
};
export var Cookie = {
    //设置cookie
    setCookie: function (name, value, exdays) {
        //name  :表示cookie的名称，比如token
        //value  :表示cookie的值
        //exdays  :表示cookie的有效时间
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = 'expires=' + d.toUTCString();
        document.cookie = name + '=' + value + '; ' + expires;
    },
    //获取cookie
    getCookie: function (name) {
        var ret, m;
        if (typeof name === 'string' && name !== '') {
            if ((m = String(document.cookie).match(new RegExp('(?:^| )' + name + '(?:(?:=([^;]*))|;|$)')))) {
                ret = m[1] ? decodeURIComponent(m[1]) : '';
            }
        }
        return ret;
    },
    // 删除cookie
    deleteCookie: function (name) {
        var exp = new Date();
        exp.setMonth(exp.getMonth() - 1);
        var cval = this.getCookie(name);
        if (cval != null) {
            document.cookie = name + '=' + cval + ';expires=' + exp.toUTCString();
        }
    },
};
export function isError(val) {
    return val instanceof Error || val.message !== void 0;
}
